import Button from '@/storybook/components/Button/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FiltersFooter.module.css';

interface FiltersFooterProps {
  onClearAll: () => void;
  onCancel: () => void;
  formId: string;
  canSubmit: boolean;
  hasDraft: boolean;
}

export const FiltersFooter: React.FC<FiltersFooterProps> = ({ onClearAll, onCancel, formId, canSubmit, hasDraft }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonContainerFooter}>
      <div className={styles.buttonContainerCenter}>
        <div className={styles.buttonContainerLeft}>
          <Button variant="text" size="M" onClick={onClearAll}>
            {t('global.filters.clearAll')}
          </Button>
        </div>
        <div className={styles.buttonContainerRight}>
          <Button variant="text" size="M" onClick={onCancel}>
            {t('global.filters.cancelButtonLabel')}
          </Button>
          <Button
            type="submit"
            form={formId}
            size="L"
            variant={hasDraft ? 'pending' : 'primary'}
            disabled={!canSubmit}
            data-testid="applyFilters"
          >
            {t('global.filters.formControls.applyButtonLabel')}
          </Button>
        </div>
      </div>
    </div>
  );
};
